module.exports = __webpack_public_path__ + "img/right-circle.e64e0569.svg";